import { render, staticRenderFns } from "./ContentFeedPrice.vue?vue&type=template&id=eb6d71d4&scoped=true&"
import script from "./ContentFeedPrice.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedPrice.vue?vue&type=script&lang=ts&"
import style0 from "./ContentFeedPrice.vue?vue&type=style&index=0&id=eb6d71d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6d71d4",
  null
  
)

export default component.exports